import { Button } from '@novaquantis/design-system';
import OnboardingStepActions from '../../../components/onboarding/OnboardingStepActions';
import { ALPACA_LINKS } from '../../../onboarding/onboardingSteps';
import {
  stepTitleClass,
  stepLeadClass,
  stepListClass,
  stepFootnoteClass,
  stepLinkSecondaryClass,
} from './stepStyles';

type Props = {
  onContinue: () => void;
  continuing: boolean;
};

const AlpacaApiKeysStep = ({ onContinue, continuing }: Props) => (
  <div>
    <h1 className={stepTitleClass}>Generate Alpaca API keys</h1>
    <p className={stepLeadClass}>
      In the Alpaca dashboard, open the API Keys section for the environment you plan to
      use (paper for testing, live after approval). Create a new key pair and copy both the
      Key ID and Secret.
    </p>
    <ul className={stepListClass}>
      <li>The secret is shown only once — store it securely before leaving the page.</li>
      <li>Use paper keys with the paper API endpoint; live keys with the live endpoint.</li>
      <li>You will paste these credentials on the next NovaQuantis step.</li>
    </ul>
    <OnboardingStepActions>
      <a href={ALPACA_LINKS.dashboard} target="_blank" rel="noopener noreferrer">
        <Button variant="outline">Open Alpaca dashboard</Button>
      </a>
      <Button type="button" onClick={onContinue} disabled={continuing} variant="glow">
        {continuing ? 'Saving…' : 'I have my API keys'}
      </Button>
    </OnboardingStepActions>
    <p className={stepFootnoteClass}>
      <a
        className={stepLinkSecondaryClass}
        href={ALPACA_LINKS.apiKeysGuide}
        target="_blank"
        rel="noopener noreferrer"
      >
        Alpaca tutorial: Get API keys &amp; connect
      </a>
      {' · '}
      <a
        className={stepLinkSecondaryClass}
        href={ALPACA_LINKS.authDocs}
        target="_blank"
        rel="noopener noreferrer"
      >
        API authentication docs
      </a>
    </p>
  </div>
);

export default AlpacaApiKeysStep;
